import React, { useEffect } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import TopNavBar from "components/TopNavBar";
import LeftSideBar from "components/LeftSideBar";
import { useDispatch, useSelector } from "react-redux";
import { toggleDrawer } from "store/slices/drawer";
import { useAuth } from "context/AuthContext";
import DashboardSubnav from "components/DashboardSubnav";

const ProjectLayOut = (props) => {
    const { projectId } = useParams();
    const { pathname } = useLocation();
    const normalizedPath = pathname.replace(/\/+$/, "");
    const isDashboardView = normalizedPath === `/projects/${projectId}` || pathname.includes("/dashboard/");

    const dispatch = useDispatch();
    const { user, getProjectPermissionInfo } = useAuth();
    // const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const customerRole = user?.roles?.includes("Customer");

    const handleHamburgerToggle = (isOpen) => {
        // setIsSidebarOpen(isOpen);
    };

    // const handleDrawerClose = () => {
    //     setIsSidebarOpen(!isSidebarOpen);
    // };
    const isSidebarOpen = useSelector((state) => state.drawer.isDrawerOpen);
    const handleDrawerClose = () => {
        dispatch(toggleDrawer());
    };

    useEffect(() => {
        if (user?.permission == undefined) {
            getProjectPermissionInfo(projectId)
        }
    }, [])

    return (
        <>
            <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                <TopNavBar
                    handleDrawer={handleDrawerClose}
                    isOpen={isSidebarOpen}
                />
                <Box
                    sx={{
                        display: "flex",
                        flexGrow: 1,
                        height: "calc(100vh - 64px)",
                    }}
                >
                    <Box
                        sx={{
                            height: "100%",
                            overflowY: "auto",
                            flexShrink: 0,
                            bgcolor: "#FFFFFF",
                            borderRight: "1px solid #E7ECF3",
                        }}
                    >
                        <LeftSideBar
                            onHamburgerToggle={handleHamburgerToggle}
                            isOpen={isSidebarOpen}
                            customerRole={customerRole}
                        />
                    </Box>
                    <Box
                        sx={{
                            flexGrow: 1,
                            overflow: "hidden",
                            bgcolor: "background.default",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <DashboardSubnav />
                        <Box
                            sx={{
                                flex: 1,
                                minHeight: 0,
                                overflowY: "auto",
                                overflowX: "auto",
                                ...(isDashboardView && {
                                    "& .MuiCard-root, & .MuiPaper-root, & .MuiAccordion-root": {
                                        borderRadius: "3px !important",
                                        overflow: "hidden",
                                    },
                                }),
                            }}
                        >
                            <Outlet />
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                <TopNavBar handleDrawer={handleDrawerClose} isOpen={isSidebarOpen} />
                
                <Box sx={{ display: "flex", flexGrow: 1, overflow: "hidden" }}>
                    <LeftSideBar onHamburgerToggle={handleHamburgerToggle} isOpen={isSidebarOpen} />

                    <Box sx={{
                        flexGrow: 1, p: 0, overflowX: "auto",
                        width: { xs: isSidebarOpen ? "calc(100vw - 200px)" : "calc(100vw - 70px)", md: "100%" },
                        boxSizing: "border-box"
                    }}>
                        <Outlet />
                    </Box>

                </Box>
            </Box> */}
        </>

    );
};

export default ProjectLayOut;
